var map = {
	"./ic_eco0.png": 826,
	"./ic_eco1.png": 827,
	"./ic_eco2.png": 828,
	"./ic_eco3.png": 829,
	"./ic_eco4.png": 830,
	"./ic_eco5.png": 831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;